import React from "react"
import { Link } from "gatsby"

const Features = () => {
  return (
    <>
      <div className="featured-services-area pt-100 pb-70">
        <div className="container">
          <div className="section-title">
            <span className="sub-title">Sản phẩm</span>
            <h2>Các sản phẩm Computer Vision của An Phát</h2>
            <p className="d-none">
              Dưới đây là các sản phẩm chính của An Phát Computer Vision
            </p>
          </div>

          <div className="row justify-content-center">
            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              <div className="single-featured-services-box">
                <div className="icon">
                  <i className="flaticon-research"></i>
                  <div className="circles-box">
                    <div className="circle-one"></div>
                    <div className="circle-two"></div>
                  </div>
                </div>

                <h3>
                  <Link to="/services-1">eKYC</Link>
                </h3>

                <p>
                Sử dụng thuật toán học sâu để xác định chính danh dựa trên chân dung, thông tin giấy tờ CMND/CCCD, hộ chiếu.
                </p>

                <Link to="/services-1" className="learn-more-btn">
                  <i className="left-icon flaticon-next-button"></i>
                  Xem thêm <i className="right-icon flaticon-next-button"></i>
                </Link>
              </div>
            </div>

            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="200"
            >
              <div className="single-featured-services-box">
                <div className="icon">
                  <i className="flaticon-speed"></i>
                  <div className="circles-box">
                    <div className="circle-one"></div>
                    <div className="circle-two"></div>
                  </div>
                </div>

                <h3>
                  <Link to="/services-2">Camera AI</Link>
                </h3>

                <p>
                Ứng dụng camera AI kết hợp thị giác máy tính và học máy. Tích hợp nhận diện và phân loại đối tượng, cải thiện an ninh và tiện ích cá nhân.
                </p>

                <Link to="/services-2" className="learn-more-btn">
                  <i className="left-icon flaticon-next-button"></i>
                  Xem thêm <i className="right-icon flaticon-next-button"></i>
                </Link>
              </div>
            </div>

            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="300"
            >
              <div className="single-featured-services-box">
                <div className="icon">
                  <i className="flaticon-email-marketing"></i>
                  <div className="circles-box">
                    <div className="circle-one"></div>
                    <div className="circle-two"></div>
                  </div>
                </div>

                <h3>
                  <Link to="/services-3">OCR</Link>
                </h3>

                <p>
                Ứng dụng OCR giúp chuyển đổi văn bản từ hình ảnh thành dữ liệu có thể xử lý, tăng cường hiệu suất và giảm lỗi nhập liệu.
                </p>

                <Link to="/services-3" className="learn-more-btn">
                  <i className="left-icon flaticon-next-button"></i>
                  Xem thêm <i className="right-icon flaticon-next-button"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Features
